import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "tabButton"]
  static values = { modelKey: String }

  connect() {
  }

  toggleMoreOptions(event) {
    this.tabTargets.forEach(card => {
      if (card.id === event.params.id) {
        card.classList.remove("hidden")
      } else {
        card.classList.add("hidden")
      }
    })

    this.tabButtonTargets.forEach(button => {
      if (button.dataset.cardsIdParam === event.params.id) {
        button.classList.add("font-medium", "border-blue-500", "text-blue-500")
        button.classList.remove("border-gray-200", "text-gray-400")
      } else {
        button.classList.remove("font-medium", "border-blue-500", "text-blue-500")
        button.classList.add("border-gray-200", "text-gray-400")
      }
    })

    // Zapisz preferencję w ustawieniach użytkownika
    if (this.hasModelKeyValue && this.modelKeyValue) {
      const isOpen = event.params.id === "more_options"
      this.savePreference(isOpen)
    }
  }

  // Zapisuje stan more_options w user_setting.fields via set_field endpoint.
  // Otwarcie zapisuje true, zamknięcie usuwa klucz (value=default).
  savePreference(isOpen) {
    const csrfToken = document.querySelector("meta[name=csrf-token]")
    const key = `more_options.${this.modelKeyValue}`
    const value = isOpen ? "true" : "default"
    const url = `/account/set_field?target=user_setting&key=${encodeURIComponent(key)}&value=${value}`

    fetch(url, {
      method: "POST",
      headers: {
        "X-CSRF-Token": csrfToken && csrfToken.content,
        Accept: "application/json",
      },
    })
  }
}
